import React, { useEffect, useRef, useState } from 'react';
import { usePrefersReducedMotion } from '../hooks/usePrefersReducedMotion';
const RESTING = {
  rx: 0,
  ry: 0,
  tx: 0,
  ty: 0
};
export function ParallaxHero() {
  const ref = useRef<HTMLDivElement>(null);
  const reducedMotion = usePrefersReducedMotion();
  const [pos, setPos] = useState(RESTING);
  useEffect(() => {
    const el = ref.current;
    // Tilt only for fine pointers (mouse) and when motion is allowed
    const finePointer = window.matchMedia?.('(pointer: fine)').matches;
    if (!el || reducedMotion || !finePointer) return;
    let frame = 0;
    const onMove = (e: MouseEvent) => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
        const y = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
        setPos({
          rx: -y * 6,
          ry: x * 6,
          tx: x * 10,
          ty: y * 10
        });
      });
    };
    const onLeave = () => setPos(RESTING);
    el.addEventListener('mousemove', onMove);
    el.addEventListener('mouseleave', onLeave);
    return () => {
      cancelAnimationFrame(frame);
      el.removeEventListener('mousemove', onMove);
      el.removeEventListener('mouseleave', onLeave);
    };
  }, [reducedMotion]);
  return <div ref={ref} className="w-full max-w-6xl mx-auto mb-16 md:mb-24" style={{
    perspective: 1200
  }} data-id="element-412" data-mp="1vvf42kt201bn">
      <div className="relative w-full rounded-2xl md:rounded-[2rem] overflow-hidden shadow-2xl" style={{
      transform: `rotateX(${pos.rx}deg) rotateY(${pos.ry}deg)`,
      transition: 'transform 150ms ease-out'
    }} data-id="element-413" data-mp="185chulbtlpky">
        <div className="relative" style={{
        transform: `translate(${pos.tx}px, ${pos.ty}px) scale(1.04)`,
        transition: 'transform 150ms ease-out'
      }} data-id="element-414" data-mp="1i1xnn8vnz4pu">
          <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&h=600&fit=crop&crop=center" alt="Tím pri práci na AI aplikácii v modernom štúdiu" width={1200} height={600} className="w-full h-56 sm:h-72 md:h-[420px] object-cover" draggable={false} data-id="element-415" data-mp="2okmeoi5s8hd9" />
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-5 md:p-10 bg-gradient-to-t from-black/70 via-black/25 to-transparent text-left" data-id="element-416" data-mp="35mjfzx0hjtg0">
          <div className="flex items-center gap-2.5 mb-2" data-id="element-417" data-mp="2cxchuz4y15va">
            <span className="w-2 h-2 rounded-full bg-emerald-400" aria-hidden="true" data-id="element-418" data-mp="2cuzto48ldz9s" />
            <span className="text-white/90 text-xs font-mono uppercase tracking-wider" data-id="element-419" data-mp="2hwpa5zel3559">Gemini AI — online</span>
          </div>
          <p className="text-white text-sm md:text-base font-medium max-w-lg" data-id="element-420" data-mp="2mtfl68bj7ajt">
            Text, obraz, video a zvuk spracované v reálnom čase.
          </p>
        </div>
      </div>
    </div>;
}